"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// inspired from
// http://www.petecorey.com/blog/2019/05/13/is-my-apollo-client-connected-to-the-server/
// https://www.apollographql.com/docs/tutorial/local-state/

var propTypes = {
  subscriptionClient: _propTypes["default"].object
};
var ConnectionStatus = function ConnectionStatus(_ref) {
  var subscriptionClient = _ref.subscriptionClient;
  var _useState = (0, _react.useState)("initializing"),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isConnected = _useState4[0],
    setIsConnected = _useState4[1];
  (0, _react.useEffect)(function () {
    // https://github.com/enisdenjo/graphql-ws/blob/1fb0275/src/client.ts#L146
    subscriptionClient.on("connecting", function () {
      setStatus("connecting");
      setIsConnected(false);
    });
    subscriptionClient.on("connected", function () {
      setStatus("connected");
      setIsConnected(true);
    });
    subscriptionClient.on("closed", function () {
      setStatus("closed");
      setIsConnected(false);
    });
    subscriptionClient.on("error", function (error) {
      setStatus("error");
      setIsConnected(false);
      console.error("graphql WS connection error:", error);
    });
  }, [subscriptionClient]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    title: JSON.stringify(status),
    style: {
      position: "absolute",
      zIndex: 999999,
      right: 0
    }
  }, isConnected ? "⚡" : "🚫");
};
ConnectionStatus.propTypes = propTypes;
var _default = exports["default"] = ConnectionStatus;